import * as React from "react";
import { IdStyles } from "../../../less/IdStyles";
export var SlideshowPage = function (_a) {
    var currentPage = _a.currentPage, hoverPage = _a.hoverPage, item = _a.item, index = _a.index;
    var isPagePrevious = index === currentPage - 1;
    var isPageNext = index === currentPage + 1;
    var isPageActive = index === currentPage;
    var isHoverPage = index === hoverPage;
    var pageClass = "";
    if (isPagePrevious) {
        pageClass = "slideshow-page__previous";
    }
    else if (isPageNext) {
        pageClass = "slideshow-page__next";
    }
    else if (isPageActive) {
        pageClass = "slideshow-page__active";
    }
    if (isHoverPage) {
        pageClass += " " + IdStyles.StateHover;
    }
    return (React.createElement("div", { className: "slideshow-page " + pageClass, key: index }, item));
};



//////////////////
// WEBPACK FOOTER
// ./src/features/generic/slideshow/SlideshowPage.tsx
// module id = 2909
// module chunks = 3